import { isMobile, isSafari, isChrome, isFirefox } from 'react-device-detect';
export default {
    handleCameraPermission,
};

async function handleCameraPermission(dispatch, dispatchDenied) {
    try {
        const [cameraPermission, audioPermission] = await Promise.all([
            navigator.permissions.query({ name: 'camera' }),
            navigator.permissions.query({ name: 'microphone' })
        ]);

        const isGranted = cameraPermission.state === 'granted' && audioPermission.state === 'granted';
        const isPrompt = cameraPermission.state === 'prompt' || audioPermission.state === 'prompt';
        if (isGranted) {
            dispatchDenied(false);
            return true;
        }
        if (isPrompt) {
            dispatchDenied(false);
            if (cameraPermission.state === 'prompt' && audioPermission.state === 'prompt') {
                return handleAskPermission(dispatch, dispatchDenied);
            }
            return cameraPermission.state === 'prompt'
                ? handleAskVideoPermission(dispatch, dispatchDenied)
                : handleAskAudioPermission(dispatch, dispatchDenied);
        }

        // If denied
        dispatchDenied(true);
        dispatch(`Camera access is currently blocked in your browser settings. Please enable it to proceed by adjusting your settings.`);
        return false;
    } catch (error) {
        dispatch('Camera permission is required');
        console.error('Error requesting camera permission:', error);
        return false;
    }
}

const handleAskAudioPermission = async (dispatch, dispatchDenied) => {
    try {
        const audioPermission = await navigator.permissions.query({ name: 'microphone' })

        if (audioPermission.state === 'granted') {
            return true
        }

        const askforpermission = await navigator.mediaDevices.getUserMedia({ audio: true });
        askforpermission.getTracks().forEach(track => track.stop());

        if (isFirefox && isMobile && handlePath() !== '/live') {
            return true
        }
        if (handlePath() !== '/live') {
            if (!(isSafari && !isChrome) && !isMobile) {
                window.location.reload()
            }
        }
        return true;
    } catch (error) {
        console.error('[handleAskAudioPermission]:', error);
        const audioPermission = await navigator.permissions.query({ name: 'microphone' })
        return handlePermissionError(dispatch, dispatchDenied, audioPermission, error);
    }
};

export const handleAskVideoPermission = async (dispatch, dispatchDenied) => {
    try {
        const cameraPermission = await navigator.permissions.query({ name: 'camera' })

        if (cameraPermission.state === 'granted') {
            return true
        }
        const askforpermission = await navigator.mediaDevices.getUserMedia({ video: true });
        askforpermission.getTracks().forEach(track => track.stop());

        if (isFirefox && isMobile && handlePath() !== '/live') {
            return true
        }
        if (handlePath() !== '/live') {
            if (!(isSafari && !isChrome) && !isMobile) {
                window.location.reload()
            }
        }
        return true;
    } catch (error) {
        console.error('[handleAskVideoPermission]:', error);
        const cameraPermission = await navigator.permissions.query({ name: 'camera' })
        return handlePermissionError(dispatch, dispatchDenied, cameraPermission, error);
    }
};

const handleAskPermission = async (dispatch, dispatchDenied) => {
    try {
        const [cameraPermission, audioPermission] = await Promise.all([
            navigator.permissions.query({ name: 'camera' }),
            navigator.permissions.query({ name: 'microphone' })
        ]);

        const isGranted = cameraPermission.state === 'granted' && audioPermission.state === 'granted';
        if (isGranted) {
            return true
        }
        const askforpermission = await navigator.mediaDevices.getUserMedia({
            video: true,
            audio: true,
        });
        askforpermission.getTracks().forEach(track => track.stop());

        if (isFirefox && isMobile && handlePath() !== '/live') {
            return true
        }
        if (handlePath() !== '/live') {
            if (!(isSafari && !isChrome) && !isMobile) {
                window.location.reload()
            }
        }

        return true;
    } catch (error) {
        const [cameraPermission, audioPermission] = await Promise.all([
            navigator.permissions.query({ name: 'camera' }),
            navigator.permissions.query({ name: 'microphone' })
        ]);

        const isPrompt = cameraPermission.state === 'prompt' || audioPermission.state === 'prompt';

        if (isFirefox || !isChrome) {
            if (error.name === "NotAllowedError" && isPrompt) {
                dispatchDenied(true);
                dispatch(
                    `Camera access is currently blocked in your browser settings. Please enable it to proceed by adjusting your settings.`
                );
                return false;
            }
        }
        if ((error.name === 'NotAllowedError' || error.name === 'NotFoundError') && !isPrompt) {
            dispatchDenied(true)
            dispatch(`Camera access is currently blocked in your browser settings. Please enable it to proceed by adjusting your settings.`);
            return false
        } else if ((isMobile || !isChrome) && isPrompt && !isFirefox) {
            dispatchDenied(true)
            dispatch(`Camera access is currently blocked in your browser settings. Please enable it to proceed by adjusting your settings.`);
            return false
        }
        else {
            dispatch(`Camera & Microphone permission is required !`);
            return false;
        }
    }
};

const handlePath = () => {
    const route = window.location.pathname;
    const baseRoute = route.split('/').slice(0, 2).join('/')
    return baseRoute
}

export const isStreamReady = (webcamRef) => {
    return (
        webcamRef.current &&
        webcamRef.current.stream instanceof MediaStream &&
        webcamRef.current.stream.active &&
        webcamRef.current.stream.getTracks().length > 0
    );
};

const handlePermissionError = (dispatch, dispatchDenied, permission, error) => {

    const isPrompt = permission.state === 'prompt'

    if (isFirefox || !isChrome) {
        if (error.name === "NotAllowedError" && isPrompt) {
            dispatchDenied(true);
            dispatch(
                `Camera access is currently blocked in your browser settings. Please enable it to proceed by adjusting your settings.`
            );
            return false;
        }
    }
    if ((error.name === 'NotAllowedError' || error.name === 'NotFoundError') && !isPrompt) {
        dispatchDenied(true)
        dispatch(`Camera access is currently blocked in your browser settings. Please enable it to proceed by adjusting your settings.`);
        return false
    } else if ((isMobile || !isChrome) && isPrompt && !isFirefox) {
        dispatchDenied(true)
        dispatch(`Camera access is currently blocked in your browser settings. Please enable it to proceed by adjusting your settings.`);
        return false
    }
    else {
        dispatch(`Camera permission is required !`);
        return false;
    }
};
